import type { Dispatch, SetStateAction } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";

interface PasswordVisibilityToggleProps {
  isPasswordVisible: boolean;
  passwordValue: string | undefined;
  setIsPasswordVisible: Dispatch<SetStateAction<boolean>>;
}

export const PasswordVisibilityToggle = ({
  passwordValue,
  isPasswordVisible,
  setIsPasswordVisible,
}: PasswordVisibilityToggleProps) => {
  const iconType = !passwordValue
    ? "16-eye-visible"
    : isPasswordVisible
      ? "16-eye-hidden"
      : "16-eye-visible";

  const handleToggleVisibility = () => {
    if (passwordValue) setIsPasswordVisible(prev => !prev);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (passwordValue && ["Enter", " "].includes(e.key)) {
      setIsPasswordVisible(prev => !prev);
      e.preventDefault();
    }
  };

  return (
    <Button
      variant="text"
      type="button"
      className={classNames(
        "absolute right-3 top-1/2 flex size-4 -translate-y-1/2 items-center justify-center focus:outline-none",
        passwordValue
          ? "cursor-pointer text-neutral-600 hover:text-neutral-800"
          : "cursor-not-allowed text-neutral-400",
      )}
      onClick={handleToggleVisibility}
      tabIndex={passwordValue ? 0 : -1}
      disabled={!passwordValue}
      onKeyDown={handleKeyDown}
    >
      <Icon
        type={iconType}
        className={classNames("h-4", {
          "text-disabled": !passwordValue,
        })}
      />
    </Button>
  );
};
